import api from '../config/api';
import { ExternalNewsFeed } from '../types/news';

export const newsService = {
  getLatest: async (): Promise<ExternalNewsFeed> => {
    const response = await api.get<ExternalNewsFeed>('/news/latest');
    return response.data;
  },

  /** Admin only — clears cache and refetches both external news sites. */
  refresh: async (): Promise<ExternalNewsFeed> => {
    const response = await api.post<ExternalNewsFeed>('/news/refresh');
    return response.data;
  },
};
